module.exports = "<div class=\"row\">\n  <div class=\"col\">\n    <h4>Observatorio de Educación para la Innovación</h4>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/inicio/inicio.component.html
// module id = ./src/app/inicio/inicio.component.html
// module chunks = main